<template>
  <div>
    <div v-if="loading" class="loading">
      <SvgLoaderMoon> </SvgLoaderMoon>
    </div>
    <div v-if="!loading && company">
      <BackButton class="u-margin-bottom-small"> </BackButton>

      <company-card :company="company" :members="users" :showDeleteCompany="showDeleteCompany"> </company-card>

      <edit-company-form :company="company" @update="updateCompany($event)"> </edit-company-form>

      <members-card :members="users"> </members-card>
    </div>
  </div>
</template>

<script>
import axiosAuth from '../../../axiosMain';
import ShowOrUpdateInput from '../../../components/Inputs/showOrUpdateInput';
import UserAvatar from '../../../components/UserAvatar';
import CreateUserModal from '../../../components/modals/CreateUserModal';
import EditButton from '../../../components/buttons/EditButton';
import SvgLoaderMoon from '../../../components/svg/SvgLoaderMoon';
import BackButton from '../../../components/buttons/BackButton';
import ModalTemplate from '../../../components/modals/ModalTemplate';
import scopesChecker from '../../../router/scopes/scopesChecker';
import CompanyCard from './CompanyCard';
import EditCompanyForm from './EditCompanyForm';
import MembersCard from './MembersCard';
import CompanyController from '@/controllers/Company/CompanyController';
import UsersController from '@/controllers/Users/UsersController';
export default {
  name: 'CompanyShow',
  components: {
    ModalTemplate,
    BackButton,
    EditButton,
    CreateUserModal,
    UserAvatar,
    ShowOrUpdateInput,
    SvgLoaderMoon,
    CompanyCard,
    EditCompanyForm,
    MembersCard,
  },
  props: {
    showDeleteCompany: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      company: null,
      users: null,
      loading: true,
    };
  },
  async mounted() {
    await this.getCompany();
    await this.getCompanyUsers();
  },
  methods: {
    checkScopes: function (action) {
      return scopesChecker(null, this.$route.name, action);
    },
    updateCompany: async function (event) {
      try {
        this.company = await CompanyController.update(this.$route.params.id, event);
        this.$store.dispatch('fetchAuthUser');
        this.$notify({
          type: 'success',
          title: 'Success!',
          text: this.$t('the_company_was_updated'),
        });
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    getCompany: async function () {
      try {
        this.company = await CompanyController.show(this.$route.params.id);
      } catch (e) {
        console.error(e);
        this.loading = false;
        this.$router.push('/settings');
      }
    },
    getCompanyUsers: async function () {
      try {
        this.users = await UsersController.indexCompany(this.company.company_id);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
